/**
 * @author vishwadeep.kapoor
 * @Date: 2019-04-25 12:15:09
 * @Last Modified by: vishwadeep
 * @Last Modified time: 2020-04-19 14:27:40
 */

import { constants } from '../../devUtils';
import endPoints from '../../config/endPoints';
import { GIF_IMPORTS } from '../../devUtils/assests';
// import { FordSecondaryDescription, NipponSecondaryDescription } from './index';
import { CLIENT_BANNERS_DESKTOP_FORD, CLIENT_BANNERS_DESKTOP_NIPPON, CLIENT_BANNERS_DESKTOP_MANIPAL } from '../HomePage/constants';
import theme from '../../theme';

export const DEFAULT_ACTION = '/ClientLogin/DEFAULT_ACTION';

export const FORD_CONFIG = {
  about_title: 'About Ford',
  about_description: `<p>Ford manufactures and exports vehicles and engines made at its integrated manufacturing facilities in Chennai, 
    Tamil Nadu and Sanand, Gujarat. Since its entry in India in 1995, Ford has invested more than US$ 2 billion to expand its manufacturing facilities and sales & service
    footprint to meet the demand in one of the world's fastest-growing auto markets. Ford India’s integrated manufacturing facility at Maraimalai Nagar, near Chennai,
    produces its award-winning range of products including the Ford EcoSport and Ford Endeavour.<br /><br /> As part of its overall commitment, Ford inaugurated its
    US$ 1 billion state-of-the-art integrated manufacturing facility in Sanand, Gujarat in March 2015. With Sanand being operational, Ford India has doubled its annual
    installed manufacturing capacity to 610,000 engines and 440,000 vehicles. The sub-four-metre compact sedan, Ford Aspire, became the first car to roll out from the new
    Ford Sanand plant. The plant also manufactures Next-Gen Figo hatchback.</p>`,
  secondary_title: 'The Beginning',
  logo: endPoints.FORD_LOGO,
  inner_logo: endPoints.FORD_LOGO,
  slider_images: CLIENT_BANNERS_DESKTOP_FORD,
  header_background: '#fff',
  h1_color: '#004377',
  midLayerTextAlign: 'left',
  login_background: '#004377',
  redirect_loginSuccess: constants.LINK_PAY_BALANCE,
  redirect_logoutSuccess: constants.LINK_CLIENT_FORD,
  client_key: 'FORD',
};

const NIPPON_CONFIG = {
  about_title: 'About Nippon Paint',
  about_description: `<p>Nippon Paint is based in Japan and has over 138 years of experience in the paint industry. The number one paint manufacturer in Asia, and among
    the leading paint manufacturers of the world.<br /><br /> Nippon Paint produces high-quality paints and coats for automotive, industrial and decorative sectors.
    Over the years, Nippon Paint has perfected its products by means of breakthrough paint technology, with an emphasis on innovation and eco-friendliness. We are driven
    by the philosophy of enhancing life through innovations – to consistently deliver paint solutions that not only serve your needs, but also protect the world we live in.
    After over ten years in the Indian market, Nippon Paint is steadily becoming a household name.<br /><br /> Apart from a range of interior, exterior and enamel finishes,
    we have many specialty products that showcase its technological prowess.</p>`,
  secondary_title: 'Our Values',
  logo: endPoints.NIPPON_LOGO,
  inner_logo: endPoints.NIPPON_LOGO,
  slider_images: CLIENT_BANNERS_DESKTOP_NIPPON,
  header_background: '#01549e',
  h1_color: '#02549e',
  midLayerTextAlign: 'center',
  login_background: '#02549e',
  redirect_loginSuccess: constants.LINK_DASHBOARD,
  redirect_logoutSuccess: constants.LINK_CLIENT_NIPPON,
  client_key: 'NIPPON',
};

const MANIPAL_CONFIG = {
  welcome_title: 'Welcome!',
  welcome_description: '<p>The ManipalCigna Brand Store, now makes ordering official ManipalCigna Health Insurance branded merchandise quick and simple. The store allows ManipalCigna employees and advisors to easily order a variety of ManipalCigna promotional products, including stationery, bags, drinkware, apparel items, and much more.</p><p>And what’s more, orders can be placed 24/7, and we will also handle the delivery of the items to any place where you choose to have your products delivered. All in all - it’s a smart one-stop-shop if you want to find a range of customized promotional products all in one place.</p><p>We’ve got what you need to succeed! Sign Up to our portal with your Email ID or Phone number to check the wide lineup of merchandise we offer, that regularly gets refreshed to reflect your needs and the requirements.</p>',
  about_title: 'How it works.',
  about_description: '<p>1. Signup entering your name, email, phone, and password.<br /> 2. Enter OTP for phone number verification.<br /> 3. Log in with your credentials.<br /> 4. Select the product from the product catalog.<br /> 5. Add the product item into the cart and checkout.<br /> 6. Enter the shipping details, save and deliver here. <br />7. Pay the amount through the payment gateway.<br /> 8. Your order will be placed and delivered to the shipping address.</p>',
  support_title: 'Support',
  support_description: '<div class="support-box margin-t-2 padding-2">Email : <a href="mailTo:team@zaggle.in">team@zaggle.in</a><br> Call : 1860 500 3748 </div>',
  portal_name: endPoints.MANIPAL_STORE_LOGO,
  portal_color: `${theme.corellBlue}`,
  logo: endPoints.MANIPAL_LOGO_SMALL,
  brand_logo: endPoints.MANIPAL_BRAND_LOGO.URL,
  inner_logo: endPoints.MANIPAL_INNER_LOGO,
  slider_images: CLIENT_BANNERS_DESKTOP_MANIPAL,
  header_background: `${theme.whiteColor}`,
  h1_color: `${theme.pillOrange}`,
  midLayerTextAlign: 'center',
  login_background: `${theme.pillOrange}`,
  redirect_loginSuccess: constants.LINK_CLIENT_MANIPAL,
  redirect_logoutSuccess: constants.LINK_CLIENT_MANIPAL,
  client_key: 'MANIPAL',
  top_banner: endPoints.MANIPAL_TOP_BANNER,
  isOnlyMerchandise: true,
};

const ZAGGLE_PROPEL_CORPORATE_GIFTING_CONFIG = {
  welcome_title: 'Welcome!',
  welcome_description: '',
  about_title: '',
  about_description: '',
  support_title: '',
  support_description: '',
  portal_name: endPoints.PROPEL_LOGO.URL,
  portal_color: `${theme.corellBlue}`,
  logo: endPoints.PROPEL_LOGO.URL,
  brand_logo: GIF_IMPORTS.ZAGGLE_LOGO_XMAS.URL,
  inner_logo: endPoints.ZAGGLE_LOGO.URL,
  slider_images: [],
  header_background: `${theme.whiteColor}`,
  h1_color: `${theme.pillOrange}`,
  midLayerTextAlign: 'center',
  login_background: `${theme.pillOrange}`,
  redirect_loginSuccess: constants.LINK_PROPEL_CORPORATE_GIFITING_HOME,
  redirect_logoutSuccess: constants.LINK_PROPEL_CORPORATE_GIFITING_HOME,
  client_key: 'PROPEL_CORPORATE_GIFTING',
  top_banner: '',
  isOnlyMerchandise: false,
};

const ZAGGLE_CONFIG = {
  logo: endPoints.ZAGGLE_LOGO.URL,
  client_key: '',
  redirect_loginSuccess: constants.LINK_ABOUTUS,
  redirect_logoutSuccess: constants.LINK_HOME,
};

const CONFIG_CLIENT_UI = (location) => {
  switch (location) {
    case constants.LINK_CLIENT_FORD:
    case FORD_CONFIG.client_key:
      return FORD_CONFIG;
    case constants.LINK_CLIENT_NIPPON:
    case NIPPON_CONFIG.client_key:
      return NIPPON_CONFIG;
    case constants.LINK_MANIPAL_ABOUTUS:
    case constants.LINK_MANIPAL_REFUN_RETURN_POLICY:
    case constants.LINK_CLIENT_MANIPAL:
    case MANIPAL_CONFIG.client_key:
      return MANIPAL_CONFIG;
    case constants.LINK_PROPEL_CORPORATE_GIFITING_HOME:
      return ZAGGLE_PROPEL_CORPORATE_GIFTING_CONFIG;
    default:
      return ZAGGLE_CONFIG;
  }
};

export { CONFIG_CLIENT_UI, MANIPAL_CONFIG,
  ZAGGLE_PROPEL_CORPORATE_GIFTING_CONFIG,
};



// WEBPACK FOOTER //
// client/containers/ClientLogin/constants.js